import { trackConfirmPopupOpen, trackConfirmPopupResumeClick } from './modal-auction-confirm.tracking';

export default [
  '$scope', 'settings', '$uibModalInstance', 'auctionApi', 'deviceService',
  function ($scope, settings, $uibModalInstance, auctionApi, deviceService) {
    const { title, bet, isDecreasingBet } = settings;

    $scope.isMobile = deviceService.isMobile;

    $scope.title = title;

    $scope.close = () => {
      $uibModalInstance.dismiss();
    };

    $scope.confirm = () => {
      $uibModalInstance.close();

      trackConfirmPopupResumeClick(isDecreasingBet);
    };

    const getPositionForecast = () => {
      $scope.isFetching = true;
      $scope.isSuccess = false;

      auctionApi.getBetPositionForecast(bet)
        .then(({ data }) => {
          $scope.isFetching = false;
          $scope.isSuccess = true;
          $scope.positionForecast = data.increaseBetsPositionsCount;
        })
        .catch(() => {
          $scope.isFetching = false;
        });
    };

    getPositionForecast();

    trackConfirmPopupOpen(isDecreasingBet);
  }
];
